import { Routes } from '@angular/router';
import { GlobalComponent } from "./component/global/global.component";
import { PageComponent } from "./component/page/page.component";
import { PostsComponent } from "./component/posts/posts.component";
import { LoginComponent } from "./component/login/login.component";
import { AuthGuard } from './guards/auth.guard';
import { ProgettiComponent } from './component/progetti/progetti.component';
import { PostComponent } from './component/post/post.component';
import { ProgettoComponent } from './component/progetto/progetto.component';
import { PagesComponent } from './component/pages/pages.component';
import { EdizioneComponent } from './component/edizione/edizione.component';
import { RouterModule  } from '@angular/router';
import { PrintBadgesComponent } from './component/print-badges/print-badges.component';
import { PresenzaComponent } from './component/presenza/presenza.component';
import { PresenzeMultipleComponent } from './component/presenze-multiple/presenze-multiple.component';

export const routes: Routes = [
  //{ path: '', component: GlobalComponent },
  { path: '', component: LoginComponent, data: { breadcrumb: 'Home' }},
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' }},
  { path: 'pages', component: PagesComponent, data: { breadcrumb: 'Pages' } },
  { path: 'pages/:slug', component: PageComponent, data: { breadcrumb: 'Page' } },
  { path: 'blog', component: PostsComponent, data: { breadcrumb: 'Posts' } },
  { path: 'blog/:slug', component: PostComponent, data: { breadcrumb: 'Post' } },
  { path: 'progetti', component: ProgettiComponent, canActivate: [AuthGuard], data: { breadcrumb: '> progetti' } },
  { path: 'progetti/:id', component: ProgettoComponent, data: { breadcrumb: '> progetti > progetto' } },
  //{ path: 'edizioni', component: EdizioniComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Edizioni' } },
  { path: 'edizione/:id', component: EdizioneComponent, data: { breadcrumb: '> progetti > progetto > edizione' } },
  { path: 'stampabadges/:id', component: PrintBadgesComponent, data: { breadcrumb: '> progetti > progetto > edizione > stampa' } },
  { path: 'stampabadges/:id/iscrizioneId/:idIscr', component: PrintBadgesComponent, data: { breadcrumb: '> progetti > progetto > edizione > stampa' } },
  { path: 'presenza/:id', component: PresenzaComponent, data: { breadcrumb: '> progetti > progetto > edizione > registra presenza' } },
  { path: 'presenze/:id', component: PresenzeMultipleComponent, data: { breadcrumb: '> progetti > progetto > edizione > registra presenze' } }
];
/*  {
    path: 'progetti', component: ProgettiComponent, canActivate: [AuthGuard], children: [
      { path: ':id', component: ProgettoComponent }
  ] },*/
